export default __webpack_public_path__ + "static/img03-458398e5a8264a5f45f6fa7f520274a0.png";